export default "__VITE_ASSET__BHdIpxk4__"